import { render, staticRenderFns } from "./AITranscriptModal.vue?vue&type=template&id=2bcbc976&"
import script from "./AITranscriptModal.vue?vue&type=script&lang=js&"
export * from "./AITranscriptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports